import React from "react";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";
import { useSeo } from "../../apis/Public";

const PageHead = (props) => {
  const { t, i18n } = useTranslation();
  const seo = useSeo();

  if (seo.isLoading || seo.isError) return <div></div>;

  return (
    <Helmet
      title={"Iman Match - "+t(props.title)}
      htmlAttributes={{ lang: i18n.language }}
      meta={seo.data.data.data}
    />
  );
};

export default PageHead;
